import { AsyncStorage, WebStorageStateStore } from 'oidc-client-ts';

export type OidcUserStorage = AsyncStorage | Storage;

type OidcConfigOptions = {
    authUrl: string;
    realm: string;
    clientId: string;
    scope: string;
    idpHint?: string;
    redirectUrl?: string;
    postLogoutRedirectUrl?: string;
    loginHint?: string;
    userStore?: OidcUserStorage;
};

export const getOidcConfig = (options: OidcConfigOptions) => {
    return {
        authority: `${options.authUrl}/realms/${options.realm}/`, // realm - e. g. "vwfs-du-cpde", "vwfs-du-abode" etc
        client_id: options.clientId, // clientId that you want to login e. g. "custPortalClient", "custPortalClientVwfs" etc.
        redirect_uri: options.redirectUrl || window.location.origin, // URL to which user will be redirected after login // window.location.origin
        post_logout_redirect_uri: options.postLogoutRedirectUrl || window.location.origin, // url to which user will be redirected after logout
        extraQueryParams: {
            kc_idp_hint: options.idpHint || 'identitykit', // IdpHint that you want to login e. g. "VWIDIdentityProvider", "idkaabovwfs" etc.
            login_hint: options.loginHint || '', // IdpHint that you want to login e. g. "VWIDIdentityProvider", "idkaabovwfs" etc.
        },
        response_type: 'code',
        scope: options.scope, // to be defined for the specific journey e. g. 'profile email phone address birthdate birthplace firstName lastName'
        automaticSilentRenew: true, // if true, access_token will be automatically fereshed in the background.
        loadUserInfo: true, // controls if additional identity data is loaded from the user info endpoint in order to populate the user's profile. You can disable it and implement a custom logic to call user                info when you need.
        onSigninCallback: () => {
            // You must provide an implementation of onSigninCallback to oidcConfig to remove the payload from the URL upon successful login. Otherwise if you refresh the page and
            // eslint-disable-next-line no-console
            console.log('Sign-in callback');
            window.history.replaceState({}, document.title, window.location.pathname);
        },
        ...(!!options.userStore ? { userStore: new WebStorageStateStore({ store: options.userStore }) } : {}),
    };
};
